
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteVacancyForm from "@/form/Settings/site/vacancy";
import SiteVacancySectionFrom from '@/form/Settings/site/vacancy_section';

import {VacancyStore} from "@/store/modules/Settings/Vacancy";
import {VacancySectionStore}  from "@/store/modules/Settings/VacancySection";
import { IVacancy, IVacancyListItem,  VacancyResponseType} from '@/entity/Settings/vacancy.types';
import { IVacancySection, IVacancySectionListItem, VacancySectionResponseType } from '@/entity/Settings/vacancy_section.types';
import {SalonsStore} from "@/store/modules/Salons";
import {CurrencyStore} from "@/store/modules/Currency";
import {ISalons} from "@/entity/salons/salons.types";
import {ICurrency} from "@/entity/currency/currency.types";

import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";

import VacancyCreateForm from "@/UI/components/forms/settings/vacancy/VacancyCreateForm.vue";
import VacancySectionCreateForm from "@/UI/components/forms/settings/vacancy/VacancySectionCreateForm.vue";

@Component({
  components: {
        PageTitle, FormGroup, VacancyCreateForm, VacancySectionCreateForm
  }
})
export default class Vacancy extends Vue {
    form = new SiteVacancyForm();
    formVacancySection = new SiteVacancySectionFrom();
    modal_form: boolean = false;
    modal_vacancy_section: boolean = false;


    get columnsVacancy(): ITableColumn[]{
        return TablesStore.vacancyColumns;
    }

    async saveVacancy(): Promise<void> {
      if (await this.form.submit(VacancyStore.create)) {
        this.modal_form = false;
        await VacancyStore.fetchAll();
      }
    }

    async saveVacancySection(): Promise<void> {
      if (await this.formVacancySection.submit(VacancySectionStore.create)) {
        this.modal_vacancy_section = false;
        await VacancySectionStore.fetchAll();
      }
    }

    async created(): Promise<void> {
      await VacancyStore.fetchAll();
      await SalonsStore.fetchAll();
      await CurrencyStore.fetchAll();
      await VacancySectionStore.fetchAll()
      this.formVacancySection.setFormData(this.vacancySections);
    }

    get vacancy(): IVacancy | null {
      return VacancyStore.vacancy;
    }

    get vacancySections() : IVacancySection | null {
      return VacancySectionStore.vacancySection;
    }

    get vacancySection() : IVacancySectionListItem | null {
      return VacancySectionStore.vacancySectionItem;
    }

    get salons(): ISalons | null {
      return SalonsStore.salons;
    }

    get currency(): ICurrency[] {
      return CurrencyStore.currency;
    }

}
